import React from 'react';
import css from './FragmentInfoStep2.module.css';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { useProjectStore } from '../../../../../../Stores/ProjectStore';
import { GetImageFromGalleries } from '@modules/Steps/Shared/Helpers/GetImageFromGalleries';
import { DEFAULT_TEMPLATE_IMG } from '@shared/Constants/Images/DefaultTemplateImg';
import { FragmentItemsTypesSection } from '@modules/Steps/Shared/Ui/Wrappers/FragmentItemsTypesSection/FragmentItemsTypesSection';
import ItemProgressBar from '@shared/Ui/ProgressBars/ItemProgressBar/ItemProgressBar';
import { FragmentInfoHeaderStep2 } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/FragmentInfoHeaderStep2/FragmentInfoHeaderStep2';
import { FragmentInfoFooterStep2 } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/FragmentInfoFooterStep2/FragmentInfoFooterStep2';
import { ItemsTypesTable } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/ItemsTypesTable/ItemsTypesTable';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { useFragmentsStore } from '../../../../../../Stores/FragmentsStore';

interface Props {
    fragment: ParsedFragmentEntity;
}

export const FragmentInfoStep2: React.FC<Props> = ({ fragment }) => {
    const { title, id, itemTypes } = fragment;

    const { isFragmentsUpdateLoading } = useFragmentsStore();

    const fragmentsViewModel = new FragmentsViewModel();

    const totalPrice = itemTypes
        ? fragmentsViewModel.getItemTypesTotal(itemTypes)
        : 0;

    const handleSave = async () => {
        const response = await fragmentsViewModel.updateParsedFragment(
            fragment.uuid
        );
        if (!response) {
            notifyErrorCustom('Failed update fragment');
            return;
        }

        notifySuccessCustom('Fragment updated successfully');
    };

    const url = fragmentsViewModel.getFragmentGallery(id);

    return (
        <FragmentItemsTypesSection>
            <FragmentInfoHeaderStep2 title={title} id={id} imgUrl={url}>
                <div className={css.progressBar}>
                    <ItemProgressBar
                        total={100}
                        current={
                            'progress' in fragment
                                ? (Number(fragment.progress) ?? 0)
                                : 0
                        }
                        selectedNotify={'%'}
                    />
                </div>
            </FragmentInfoHeaderStep2>
            <ItemsTypesTable itemTypes={itemTypes ?? []} />
            <FragmentInfoFooterStep2
                totalPrice={totalPrice}
                onSave={handleSave}
                isDisabled={isFragmentsUpdateLoading}
            />
        </FragmentItemsTypesSection>
    );
};
